import { IStyleFunctionOrObject, ITextFieldStyleProps, ITextFieldStyles, mergeStyles } from "@fluentui/react";

export const textFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #F0F0F0',
        width: '100%',
        height: '5dvh',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        border: '1px solid #F0F0F0',
        borderRadius: '5px'
    }
}

export const mdTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #F0F0F0',
        width: '100%',
        height: '6dvh',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        border: '1px solid #F0F0F0',
        borderRadius: '5px'
    }
}

export const smTextFieldStyles: IStyleFunctionOrObject<ITextFieldStyleProps, ITextFieldStyles> = {
    root: {
        width: '100%',
        borderRadius: '5px',
    },
    field: {
        fontFamily: 'Nunito',
        fontWeight: 500,
        width: '100%',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px',
    },
    fieldGroup: {
        border: '1px solid #F0F0F0',
        width: '100%',
        height: '5dvh',
        backgroundColor: '#F0F0F0',
        borderRadius: '5px'
    },
    wrapper: {
        border: '1px solid #F0F0F0',
        borderRadius: '5px'
    }
}

export const rowContainerStyles = mergeStyles([{
    height: '4dvh',
    marginBottom: '1dvh'
}]);

export const listContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: '2dvh',
    paddingRight: '1dvh',
    height: '40dvh',
    overflowY: 'auto'
}]);

export const xxlListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: '2dvh',
    paddingRight: '1dvh',
    height: '38dvh',
    overflowY: 'auto'
}]);

export const xlListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: '2dvh',
    paddingRight: '1dvh',
    height: '36dvh',
    overflowY: 'auto'
}]);

export const lgListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: '2dvh',
    paddingRight: '1dvh',
    height: '38dvh',
    overflowY: 'auto'
}]);

export const mdListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: '2dvh',
    paddingRight: '1dvh',
    height: '39dvh',
    overflowY: 'auto'
}]);

export const smListContainerStyles = mergeStyles([{
    width: '100%',
    marginTop: '2dvh',
    paddingRight: '1dvh',
    height: '40dvh',
    overflowY: 'auto'
}]);

export const checkboxContainerStyles = mergeStyles([{
    width: '10%',
}]);

export const descriptionContainerStyles = mergeStyles([{
    width: '90%'
}]);

//#region APP TILE TITLE

export const titleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1.2rem',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xxlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.95rem, 2.5vw, 1rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const xlTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.9rem, 2.5vw, 0.95rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const lgTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: '1rem',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const mdTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.8rem, 2.5vw, 0.85rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

export const smTitleStyles = mergeStyles([{
    fontFamily: 'Nunito',
    fontSize: 'clamp(0.75rem, 2.5vw, 0.8rem)',
    fontWeight: 600,
    color: '#2A7DE1',

    textAlign: 'left'
}]);

//#endregion APP TILE TITLE

export const registerMigrationContainerStyles = mergeStyles([{
    width: '100%',
    padding: '1dvh',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    borderRadius: '5px'
}]);

export const registerMigrationContainerSelectedStyles = mergeStyles([{
    width: '100%',
    backgroundColor: '#F0F0F0',
    cursor: 'pointer',
    borderRadius: '5px',
    border: '2px solid #a9c963'
}]);

export const registerMigrationInnerContainerSelectedStyles = mergeStyles([{
    width: 'inherit',
    padding: '1dvh',
    backgroundColor: 'rgba(169, 201, 99, 0.2)'
}]);

export const registerMigrationTextContainerStyles = mergeStyles([{
    gap: '0.5dvh',
}]);